// services/BaseDynamicsService.js
import axios from "axios";
import api from "../system/api";

export default class BaseCrmEntity {
    constructor(entityName, entityPluralName, entityLocalName, entityTypeCode) {
        this.entityName = entityName;
        this.entityPluralName = entityPluralName;
        this.entityLocalName = entityLocalName;
        this.entityTypeCode = entityTypeCode;
    }

    async fetch(fetchXml) {
        const url = `/Fetch/${this.entityPluralName}`;
        try {
            const response = await api.post(url, fetchXml);
            return response.data;
        }catch (e) {
            throw e;
        }

    }

    async create(data) {
        const url = `/Proxy/${this.entityPluralName}`;
        const headerData = {headers: { "Content-Type": 'application/json' }}
        try {
            return await api.post(url, data, headerData);
        }catch (e){
            throw e
        }
    }

    async update(id, data) {
        const url = `/Proxy/${this.entityPluralName}(${id})`;
        const headerData = {headers: { "Content-Type": 'application/json' }}
        try {
            return await api.patch(url, data, headerData);
        }catch (e) {
            throw e
        }
    }

    async delete(id) {
        const url = `/Proxy/${this.entityPluralName}(${id})`;
        try {
            return await api.delete(url);
        }catch (e){
            throw e;
        }
    }
}
